module.exports = __webpack_public_path__ + "img/huoping.53b0e097.png";